<template>
  <el-dialog
    v-model="value"
    :width="sizesWidthHeightMap[props.size][0]"
    :style="`
      --el-dialog-height: ${sizesWidthHeightMap[props.size][1]};
      ${isKeyboardOpen ? `height: ${dialogVisualViewportHeight}px;` : ''}
    `"
    :show-close="false"
    :class="[
      props.class,
      props.unbounded ? 'el-dialog--unbounded' : '',
      `el-dialog--${props.size}`,
    ]"
    :close-on-click-modal="!props.persistent"
    :close-on-press-escape="!props.persistent"
    :fullscreen="!grid.xs"
    align-center
    append-to-body
    @open="onOpen"
    @close="onClose"
  >
    <template
      v-if="$slots.header"
      #header="{ close }"
    >
      <slot
        name="header"
        :close="close"
      />
    </template>
    <template #default>
      <slot />
    </template>
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script setup>
const props = defineProps(buildProps({
  modelValue: {
    type: Boolean,
    required: false,
  },
  size: {
    type: String,
    values: ['small-hug', 'small', 'medium', 'medium-hug', 'large', 'full'],
    default: 'medium',
  },
  class: {
    type: String,
    default: '',
  },
  unbounded: {
    type: Boolean,
    default: false,
  },
  persistent: {
    type: Boolean,
    default: false,
  },
}));

const emit = defineEmits(['update:modelValue']);

// Refs
const sizesWidthHeightMap = {
  'small-hug': ['33.75rem', 'auto'],
  small: ['33.75rem', '37.5rem'],
  medium: ['57.5rem', '45rem'],
  'medium-hug': ['57.5rem', 'auto'],
  large: ['72.5rem', '45rem'],
  full: ['100%', '100%'],
};
const viewportListener = ref(null);
const dialogVisualViewportHeight = ref(null);
const isKeyboardOpen = ref(false);
const value = useVModel(props, 'modelValue', emit);

// Methods
const onOpen = () => {
  viewportListener.value = useEventListener(window.visualViewport, 'resize', () => {
    window.scrollTo(0, 0);
    const minKeyboardHeight = 300;
    dialogVisualViewportHeight.value = window.visualViewport.height;
    isKeyboardOpen.value = window.screen.height - minKeyboardHeight > window.visualViewport.height;
  });
};

const onClose = () => {
  isKeyboardOpen.value = false;
  viewportListener?.value?.();
};
</script>
